import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import SubmittedFormsEmployeeTable from './SubmittedFormsEmployeeTable'
import SubmittedEmployeeView from './SubmittedEmployeeView'
import helpers from '../../utils/helpers'
import OButton from 'components/reusable/OButton'
import CustomSelect from 'components/reusable/CustomSelect'
import OSearch from 'components/reusable/OSearch'
import { formStatusOptions } from 'utils/constants'

const SubmittedFormsEmployee = () => {
  const { updatePageName } = useContext(AuthContext)
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({})
  const [submitEmployeeList, setSubmitEmployeeList] = useState([])
  const [allowedMinute, setAllowedMinute] = useState(0)
  const [currentItem, setCurrentItem] = useState('')
  const [submitEmployeeView, setSubmitEmployeeView] = useState(false)
  const [isLoading, setIsLoading] = useState(false) // ✅ new
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleView = item => {
    setCurrentItem(item)
    setSubmitEmployeeView(!submitEmployeeView)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allSubmitEmployeeList = async data => {
    try {
      setIsLoading(true) // ✅ start loading
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && submitEmployeeList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          submitEmployeeList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        // status: category,
        formStatus: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.submitFormByEmployee
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setSubmitEmployeeList(response?.finalData?.docs)
      setAllowedMinute(response?.hrHour?.allowedHrs)
      setPaginationObj({
        ...paginationObj,
        page: response?.finalData?.page,
        pageCount: response?.finalData?.totalPages,
        perPageItem: response?.finalData?.limit,
        totalItems: response?.finalData?.totalDocs
      })
    } catch (error) {
      console.log('error in get all employee list==>>>>', error.message)
    } finally {
      setIsLoading(false) // ✅ stop loading
    }
  }

  useEffect(() => {
    allSubmitEmployeeList()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      searchKey: '',
      startDate: '',
      category: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('NAV_SUBMITTED_FORMS_BY_EMPLOYEE'))
  }, [])

  const statusPage = e => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true })
    setPage(1)
  }

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] gap-2 2xl:flex px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center flex-wrap lg:pt-0 pt-3'>
                  <div className='relative flex mb-3 items-center'>
                    <OSearch
                      placeholder={t('SEARCH_BY_EMPLOYEE_NAME')}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <CustomSelect
                    id='category'
                    name='category'
                    options={formStatusOptions}
                    placeholder='O_ALL'
                    value={filterData.category}
                    onChange={statusPage}
                    t={t}
                  />

                  <OButton
                    label='Reset'
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                    type='button'
                    onClick={handleReset}
                  />
                </div>
              </div>
            </form>

            <SubmittedFormsEmployeeTable
              submitEmployeeList={submitEmployeeList}
              allSubmitEmployeeList={allSubmitEmployeeList}
              page={page}
              handleView={handleView}
              currentItem={currentItem}
              submitEmployeeView={submitEmployeeView}
              setSort={setSort}
              sort={sort}
              isLoading={isLoading} // ✅ pass down
            />
            {submitEmployeeView && (
              <SubmittedEmployeeView
                submitEmployeeView={submitEmployeeView}
                setSubmitEmployeeView={setSubmitEmployeeView}
                currentItem={currentItem}
                handleView={handleView}
                allSubmitEmployeeList={allSubmitEmployeeList}
                allowedMinute={allowedMinute}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default SubmittedFormsEmployee